var _desc, _defs, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobpilot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "JobPilot.ai Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Rounded gradient square with a stylized briefcase and a sparkle to represent AI assistance.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 64,
    y1: 64,
    x2: 448,
    y2: 448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6366F1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 12,
    floodOpacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 448,
    height: 448,
    rx: 96,
    fill: "url(#g1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 196,
    width: 256,
    height: 168,
    rx: 24,
    fill: "white",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 176,
    width: 256,
    height: 48,
    rx: 16,
    fill: "white",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 144,
    width: 88,
    height: 28,
    rx: 14,
    fill: "white",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 232,
    width: 16,
    height: 28,
    rx: 4,
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 264,
    width: 16,
    height: 12,
    rx: 3,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 224,
    width: 256,
    height: 2,
    fill: "#E5E7EB",
    opacity: 0.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(352 144) rotate(-10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0 L28 14 L42 18 L28 22 L24 36 L20 22 L6 18 L20 14 Z",
    fill: "white",
    opacity: 0.95
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobpilot);
export default __webpack_public_path__ + "static/media/jobpilot.4c14b9ffde4551ee2d96083610d5aa19.svg";
export { ForwardRef as ReactComponent };